var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3H7C7 1.3 8.3 0 10 0V2C9.4 2 9 2.4 9 3ZM17 3H15C15 2.4 14.6 2 14 2V0C15.7 0 17 1.3 17 3ZM17 6H7V3H9V4H15V3H17V6ZM10 0H14V2H10V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6H3C2.4 6 2 5.6 2 5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5C22 5.6 21.6 6 21 6ZM19 24H5C4.4 24 4 23.6 4 23V9C4 8.4 4.4 8 5 8H19C19.6 8 20 8.4 20 9V23C20 23.6 19.6 24 19 24ZM6 22H18V10H6V22Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C9.4 20 9 19.6 9 19V13C9 12.4 9.4 12 10 12C10.6 12 11 12.4 11 13V19C11 19.6 10.6 20 10 20ZM14 20C13.4 20 13 19.6 13 19V13C13 12.4 13.4 12 14 12C14.6 12 15 12.4 15 13V19C15 19.6 14.6 20 14 20Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.4795bed8870772c6f796b55aec7c1182.svg";
export { ForwardRef as ReactComponent };